<template>
  <div class="cards-container">
    <div v-for="obj in news" :key="obj.id" class="card-article" @click="goToPublication(obj.id)">

      <div class="image-wrapper">
        <b-skeleton-img v-if="loadingNewsIds.includes(obj.id)" no-aspect height="200px"></b-skeleton-img>

        <img v-else class="image-content" :src="obj.image || fallbackImage" @error="handleImageError">
      </div>

      <div class="card-body">
        <div class="title-news">{{ obj.title }}</div>
        <div class="text-date">{{ formatDate(obj.createdAt) }}</div>
        <p class="text-news">
          {{ obj.coverCallout }}
        </p>

        <div class="text-right link-ler-mais" @click="goToPublication(obj.id)" style="cursor: pointer;">
          Ler mais
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import fallbackImage from '@/assets/images/image-error.svg';
import RoutesPaths from '../../../router/router-structure/routes-paths';

export default {
  props: {
    loadingNewsIds: {
      type: Array,
      default: () => []
    },
    news: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  data() {
    return {
      fallbackImage: fallbackImage
    }
  },
  methods: {
    handleImageError(event) {
      event.target.src = fallbackImage;
    },
    formatDate(dateString) {
      if (!dateString) return "";

      const date = new Date(dateString);

      return date.toLocaleDateString('pt-BR', {
        timeZone: 'UTC'
      });
    },
    goToPublication(id) {
      this.$router.push({
        path: RoutesPaths.connection.preview(id)
      });
    },
  }
}
</script>

<style scoped>
.cards-container {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 30px;
  margin-bottom: 24px;
}

/* De telas médias (tablets) para baixo, vira 1 coluna */
@media (max-width: 992px) {
  .cards-container {
    grid-template-columns: 1fr;
  }
}

.card-article {
  border: 1px solid #DFDFDF;
  border-radius: 8px;
  background: #F4F6F6;
  overflow: hidden;
  font-family: "Trebuchet MS", sans-serif;
  display: flex;
  flex-direction: column;
  cursor: pointer;
}

.image-content {
  width: 100%;
  height: 200px;
  object-fit: cover;
  display: block;
}

.card-body {
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 12px;
  flex-grow: 1;
}

.title-news {
  color: #212529;
  font-size: 16px;
  font-weight: 700;
  line-height: 1.3;
  margin: 0;
}

.text-date {
  color: #6C757D;
  font-size: 14px;
}

.text-news {
  color: #495057;
  font-size: 12px;
  line-height: 1.5;
  margin: 0;
}

.link-ler-mais {
  text-align: right;
  color: #007A4A;
  text-decoration: none;
  font-family: "Trebuchet MS";
  font-size: 16px;
  cursor: pointer;
  margin-top: auto;
}

.link-ler-mais:hover {
  text-decoration: underline;
}

.image-wrapper {
  width: 100%;
  height: 200px;
  overflow: hidden;
}



</style>